import api from './api';

export type CopyType = 'first_touch' | 'follow_up' | 'sequence' | 'cta';
export type Seniority = 'ic' | 'manager' | 'vp';

export interface GenerateCopyInput {
  type: CopyType;
  offerId?: string;
  icpId?: string;
  personaId?: string;
  product?: string;
  targetPersona?: string;
  seniority?: Seniority;
  angle?: string;
  trigger?: string;
  tone?: string;
  language?: string;
  followUpNumber?: number;
  previousEmail?: string;
  extra?: string;
}

export interface CopyResult {
  type: CopyType;
  content: string;
  provider: string;
  model: string;
  documentId?: string;
}

export interface CopyAnalysis {
  scores: Record<string, number>;
  penalties: number;
  overall: number;
  redFlags: string[];
  issues: string[];
  rewrite: { subject: string; body: string };
  verdict: string;
}

export interface AnalyzeResult {
  analysis: CopyAnalysis | null;
  raw?: string;
  provider: string;
  model: string;
  documentId?: string;
}

class CopywritingService {
  async generate(input: GenerateCopyInput): Promise<CopyResult> {
    const response = await api.post('/copywriting/generate', input);
    return response.data;
  }

  async analyze(email: string, seniority?: Seniority, language?: string): Promise<AnalyzeResult> {
    const response = await api.post('/copywriting/analyze', { email, seniority, language });
    return response.data;
  }
}

const copywritingService = new CopywritingService();
export default copywritingService;
